module.exports = __webpack_public_path__ + "static/csslayers-1534512fc72a19b9ca79e89d5c938dbc.png";